import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NavbarAdmin.css'; // New CSS file
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { auth } from '../firebase';

const NavbarAdmin = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    auth.signOut().then(() => {
      console.log("User signed out successfully");
      navigate('/la-connexion-de-ladmin-ong-el-wifak-bargou'); // Redirect to login or another page after logout
    }).catch((error) => {
      console.error("Error signing out:", error);
    });
  };

  return (
    <nav className='nav_admin'>
      <div className='nav__menu_admin'>
        <Link to='/la-connexion-de-ladmin-ong-el-wifak-bargou/main' className='nav__link_ admin'>
          Admin
        </Link>
        <span onClick={handleLogout} className='logout-icon'>
          <FontAwesomeIcon icon={faSignOutAlt} className='head-icon_admin'/>
        </span>
      </div>
    </nav>
  );
};

export default NavbarAdmin;
